export default {
      id: "icon-plus-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-plus",
      toString: function () {
        return this.url;
      }
    }